import type { ReactNode } from "react";
import { Calendar, Clock, Star } from "lucide-react";

import type { SurveyAdminDetailResponse } from "../types/survey.types";

interface SurveyInfoCardsProps {
  survey: SurveyAdminDetailResponse;
}

function InfoCard({ icon, title, value }: { icon: ReactNode; title: string; value: ReactNode }) {
  return (
    <div className="flex items-center gap-3 p-3 bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700">
      <div
        className="flex items-center justify-center w-8 h-8 rounded-lg"
        style={{ backgroundColor: "#F2FCFA" }}
      >
        {icon}
      </div>
      <div>
        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{title}</p>
        <p className="text-sm text-gray-600 dark:text-gray-300">{value}</p>
      </div>
    </div>
  );
}

export default function SurveyInfoCards({ survey }: SurveyInfoCardsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <InfoCard
        icon={<Calendar className="h-5 w-5 text-green-600 dark:text-green-400" />}
        title="Created"
        value={new Date(survey.created_at).toLocaleDateString()}
      />
      <InfoCard
        icon={<Star className="h-5 w-5 text-green-600 dark:text-green-400" />}
        title="Campaign / Program"
        value={survey.campaign ? `${survey.campaign.name} / ${survey.campaign.programName}` : "—"}
      />
      <InfoCard
        icon={<Clock className="h-5 w-5 text-green-600 dark:text-green-400" />}
        title="End Date"
        value={new Date(survey.end_time).toLocaleDateString()}
      />
      <InfoCard
        icon={<Star className="h-5 w-5 text-green-600 dark:text-green-400" />}
        title="Points"
        value={`${survey.points} points`}
      />
    </div>
  );
}
